// db-init.js

document.addEventListener("DOMContentLoaded", async () => {
  // run after first paint (smoother + avoids idle callback violations)
  const afterPaint = (fn) => requestAnimationFrame(() => setTimeout(fn, 0));
    document.documentElement.classList.add("js-loaded");
  // cache our welcome banner
  const welcome = document.getElementById("welcomeText");
  // helper to fade out then remove
  function fadeOut(el, duration = 500) {
    if (!el) return;
    el.style.opacity = '1';
    // trigger the CSS transition
    requestAnimationFrame(() => {
      el.style.opacity = '0';
    });
    // after the transition, remove from DOM
    setTimeout(() => {
      if (el.parentNode) el.parentNode.removeChild(el);
    }, duration);
  }
  if (window.initDarkModeToggle) window.initDarkModeToggle();
  if (window.bindStaticUIEvents) window.bindStaticUIEvents();
  populateProductTypeFilter();
  
// ——— 1) grab everything ———
const titleNav  = document.querySelector(".db-title-nav");
const titleText = document.querySelector(".gear-db-title");
const slogan    = document.querySelector(".gear-db-slogan");
const buttons   = document.getElementById("productTypeButtons");

if (titleNav && titleText && slogan && buttons) {
  // ——— 2) initial load: shine → reveal slogan → fade in buttons ———
  // a) instantly center & scale (no slide)
  titleNav.style.transition = "none";
  titleNav.classList.add("centered");
  void titleNav.offsetWidth;
  titleNav.style.transition = "";

  // b) title shine
  titleText.classList.add("shine");

  // c) after shine (0.8s now, or your chosen duration):
  setTimeout(() => {
    // reveal slogan via clip-path
    slogan.classList.add("reveal");

    // once that clip-path finishes (1s), fade in buttons
    slogan.addEventListener("transitionend", function onReveal(ev) {
      if (ev.propertyName === "clip-path") {
        buttons.classList.add("fade-in");
        slogan.removeEventListener("transitionend", onReveal);
      }
    });
  }, 800);  // ← match your shine duration
  

  // ——— 3) click a product-type: slide back, hide texts & remove slogan ———
buttons.addEventListener("click", (e) => {
  if (!e.target.closest(".type-filter-btn")) return;

  // 1) slide nav/title back up
  titleNav.classList.remove("centered");

  // 2) hide helper texts
  document
    .querySelectorAll(".type-filter-text")
    .forEach(el => el.style.display = "none");

  // 3) immediately hide the slogan
  slogan.style.transition = "none";
  slogan.style.display    = "none";

  // 4) force the buttons to fade in (fixes the deep-link case)
  buttons.classList.add("fade-in");
});
}

  afterPaint(() => {
    if (!document.getElementById("sidebarFilterPanel")) {
      injectSidebarFilterUI();
    }
    afterPaint(() => {
      const sidebar = document.getElementById("sidebarFilterPanel");
      const toggle  = document.getElementById("sidebarToggleBtn");
      if (sidebar && toggle) bindSidebarToggleEvents();
    });
  });

  // guard so we don’t bind twice elsewhere in this file
  if (!window.__uiBoundOnce) {
    window.__uiBoundOnce = true;
    afterPaint(() => bindUIEvents());
  }

  window._deepLinking = true;
  const originalURL = window.location.href;
  const params = new URLSearchParams(window.location.search);
  const typeFromUrl = params.get("type");

  if (typeFromUrl) {
    const btn = document.querySelector(
      `.type-filter-btn[data-type="${typeFromUrl}"]`
    );
    if (btn) btn.click();
  }

// make these available everywhere:
window.welcome = document.getElementById("welcomeText");

window.showTableLoader = () => {
  document
    .getElementById("tableLoadingIndicator")
    ?.style.setProperty("display","flex","important");
  if (window.welcome) fadeOut(window.welcome);
};
window.hideTableLoader = () => {
  document
    .getElementById("tableLoadingIndicator")
    ?.style.setProperty("display","none","important");
  if (window.welcome) fadeOut(window.welcome);
};

  
// 1️⃣ your rotating “quips”
const loaderMessages = [
  "Recalculating DPI…",
  "Injecting smoothness…",
  "Leveling up friction stats…",
  "Ready, set, glide…"
];
let loaderIdx = 0;
const loaderTextEl = document.getElementById("loaderText");

if (loaderTextEl) {
  // immediately show the first message
  loaderTextEl.textContent = loaderMessages[0];
  // every 3s, rotate
  setInterval(() => {
    loaderIdx = (loaderIdx + 1) % loaderMessages.length;
    loaderTextEl.textContent = loaderMessages[loaderIdx];
  }, 3000);
}
  
const tableObserver = new MutationObserver(() => {
  const tbody = document.querySelector("#productsTableBody");
  if (tbody && tbody.children.length > 0) {
    tableObserver.disconnect();

    hideTableLoader();
    document.body.classList.add("geardb-loaded");

    if (window.initSidebarPositioning) window.initSidebarPositioning();

    if (typeFromUrl) {
      const params = new URLSearchParams(window.location.search);

      const grouped = {};
      for (const [key, value] of params.entries()) {
        if (key === "type") continue;
        if (!grouped[key]) grouped[key] = [];
        grouped[key].push(decodeURIComponent(value));
      }

      Object.entries(grouped).forEach(([key, values]) => {
        values.forEach((val) => {
          const checkbox = document.querySelector(
            `.sidebar-filter-checkbox[data-column="${key}"][value="${val}"]`
          );
          if (checkbox) checkbox.checked = true;
        });

        const isMin = key.endsWith("_min");
        const isMax = key.endsWith("_max");
        const baseKey = key.replace(/_(min|max)$/, "");
        const input = document.getElementById(
          isMin ? `sidebar-min-${baseKey}` :
          isMax ? `sidebar-max-${baseKey}` :
          null
        );
        if (input) input.value = values[0];

        const span = document.querySelector(
          `.selected-filter[data-column="${key}"]`
        );
        if (span) span.textContent = values.join(", ");
      });

      applyColumnFilters();
      highlightFilteredColumns();
      history.replaceState({}, "", originalURL);
    }

    window._deepLinking = false;
  }
});

// IMPORTANT: start the observer OUTSIDE the callback
tableObserver.observe(document.body, { childList: true, subtree: true });

  const savedComparisonData = loadLocal("selectedComparisonProducts", []);
  if (savedComparisonData.length > 0) {
    selectedProductsForComparison = savedComparisonData;
  }

  const compareParam = new URLSearchParams(window.location.search).get(
    "compare"
  );
if (compareParam) {
  try {
    const ids = JSON.parse(atob(compareParam));
    const tryOpen = () => {
      const ready = ids.every((id) => productMap[id]);
      if (!ready) return;
      selectedProductsForComparison = ids.map((id) => productMap[id]);
      openCompareModal();
      window.removeEventListener('db:table-rendered', tryOpen);
    };
    window.addEventListener('db:table-rendered', tryOpen);
    // also try once in case the table is already ready
    tryOpen();
  } catch (err) {
    console.warn("Invalid compare link:", err);
  }
}

  const favs = loadLocal("favoritedProducts", []);
  if (!Array.isArray(favs)) {
    localStorage.removeItem("favoritedProducts");
  }
  renderSavedComparisons();
  updateCompareTrayUI();
  updateFavoritesUIVisibility();

  const shareBtn = document.getElementById("nativeShareBtn");
  const fullscreenBtn = document.getElementById("fullscreenToggleBtn");
  if (navigator.share && shareBtn) shareBtn.style.display = "inline-block";
  if (fullscreenBtn) fullscreenBtn.style.display = "inline-block";

  initFullscreenToggle();
  updateFilterButtonsVisibility();
  updateCompareButtonsVisibility();

    // ── c) Optional “initial fire” for grid‐view CSS offset ──
    if (isGridView) {
      // calculate and write the --grid-offset var so .scrollable works immediately
      updateGridOffset();
    }
    // recalc on window resize
    window.addEventListener("resize", () => {
      if (isGridView) updateGridOffset();
    });
});

window.addEventListener("load", () => {
  const params = new URLSearchParams(window.location.search);
  if (params.has("tier")) {
    try {
      const raw = params.get("tier");
      const json = atob(raw);
      const tierData = JSON.parse(json);
      saveLocal("tierList", tierData);
      openTierListModal();
    } catch (e) {
      console.warn("⚠️ Invalid tier data in URL:", e);
    }
  }
});

// ── After-login Quick-View restore ───────────────────
;(function() {
  const pid = sessionStorage.getItem('quickReturnProduct');
  if (!pid) return;

  if (window.location.pathname === '/pages/geardb') {
    // open the modal
    openProductModalById(pid);
    // clean up
    sessionStorage.removeItem('quickReturnProduct');

    // strip the ?quick= so it won't auto-open again
    const params = new URLSearchParams(location.search);
    params.delete('quick');
    const newQS = params.toString();
    const newURL = newQS ? `${location.pathname}?${newQS}` : location.pathname;
    history.replaceState(null, '', newURL);
  }
})();
